<template>
    <q-layout class="primary-border-dark" view="hhh lpr fff">
        <q-layout-header>
            <q-toolbar color="primary" class="q-pa-md">
                <q-btn flat dense round @click="leftDrawerOpen = !leftDrawerOpen">
                    <q-icon name="menu" />
                </q-btn>
                <q-toolbar-title>
                    Associated General Contractors of Minnesota
                </q-toolbar-title>
                <div class="block q-mt-sm">
                    <div class="row gutter-sm">
                        <div class="col">
                            <!-- icon -->
                        </div>
                        <div class="col">
                            <account-modal :value="user"></account-modal>
                        </div>
                        <div class="col on-left on-right">
                            <q-btn dense round flat icon="exit_to_app" @click.native="logout" />
                        </div>
                    </div>
                </div>
            </q-toolbar>
        </q-layout-header>
        <q-layout-drawer :breakpoint="1200" content-class="bg-grey-3" v-model="leftDrawerOpen" :mini="mini">
            <div class="bg-blue-grey-9 text-center q-pa-md text-white">
                Admin Navigation
            </div>
            <!--<q-item-->
                <!--link to="/dashboard"-->
            <!--&gt;-->
                <!--<q-item-side icon="dashboard" color="secondary" class="q-caption" />-->
                <!--<q-item-main>-->
                    <!--<q-item-tile label>Dashboard</q-item-tile>-->
                <!--</q-item-main>-->
            <!--</q-item>-->
            <sidebar-nav
                :item="item" v-for="(item, index) in routeNodes" :key="index"
            ></sidebar-nav>
            <!--<q-list no-border link separator style="padding-top: 0">-->
                <!--&lt;!&ndash; menu link &ndash;&gt;-->
                <!--<q-item link exact to="/">-->
                    <!--<q-item-side icon="dashboard" color="secondary" class="q-caption" />-->
                    <!--<q-item-main>-->
                        <!--<q-item-tile label>Dashboard</q-item-tile>-->
                    <!--</q-item-main>-->
                <!--</q-item>-->
                <!--<q-item link to="/company">-->
                    <!--<q-item-side icon="business" color="secondary" class="q-caption" />-->
                    <!--<q-item-main>-->
                        <!--<q-item-tile label>Companies</q-item-tile>-->
                    <!--</q-item-main>-->
                <!--</q-item>-->
                <!--<q-item link to="/person">-->
                    <!--<q-item-side icon="people" color="secondary" class="q-caption" />-->
                    <!--<q-item-main>-->
                        <!--<q-item-tile label>People</q-item-tile>-->
                    <!--</q-item-main>-->
                <!--</q-item>-->
                <!--<q-item link to="/event">-->
                    <!--<q-item-side icon="event_available" color="secondary" class="q-caption" />-->
                    <!--<q-item-main>-->
                        <!--<q-item-tile label>Events</q-item-tile>-->
                    <!--</q-item-main>-->
                <!--</q-item>-->
                <!--<q-item link to="/contract">-->
                    <!--<q-item-side icon="archive" color="secondary" class="q-caption" />-->
                    <!--<q-item-main>-->
                        <!--<q-item-tile label>Contracts</q-item-tile>-->
                    <!--</q-item-main>-->
                <!--</q-item>-->
                <!--<q-item link to="/user">-->
                    <!--<q-item-side icon="account_circle" color="secondary" class="q-caption" />-->
                    <!--<q-item-main>-->
                        <!--<q-item-tile label>Users</q-item-tile>-->
                    <!--</q-item-main>-->
                <!--</q-item>-->
                <!--<q-item link to="/file">-->
                    <!--<q-item-side icon="folder_shared" color="secondary" class="q-caption" />-->
                    <!--<q-item-main>-->
                        <!--<q-item-tile label>Files</q-item-tile>-->
                    <!--</q-item-main>-->
                <!--</q-item>-->
            <!--</q-list>-->
        </q-layout-drawer>
        <q-page-container>
            <q-toolbar color="blue-grey-1">
                <breadcrumbs :routes="[]" />
            </q-toolbar>
            <router-view />
        </q-page-container>
        <q-page-sticky position="bottom-right" :offset="[18, 18]">
            <q-btn v-back-to-top round color="secondary" icon="keyboard_arrow_up" />
        </q-page-sticky>
    </q-layout>
</template>
<script>
  import {mapActions, mapGetters} from 'vuex'
  import AccountModal from '../components/accountModal'
  import SidebarNav from '../components/layout/SidebarNav'
  import navHelper from '../router/navHelper'

  export default {
  name: 'LayoutAdmin',
  components: { AccountModal, SidebarNav },
  data () {
    return {
      leftDrawerOpen: true,
      mini: false,
      ready: false,
      navFilter: ''
    }
  },
  computed: {
    ...mapGetters('auth', ['user']),
    userName () {
      return this.user ? this.user.name : ''
    },
    routeNodes () {
      return navHelper
    }
  },
  methods: {
    ...mapActions('auth', ['userLogout']),
    async logout () {
      try {
        await this.userLogout()
      } catch (e) {
        // console.log(e)
      }
      this.$router.replace({ path: '/auth/login' })
      this.$q.notify({
        message: 'You have been logged out successfully',
        type: 'positive'
      })
      location.reload()
    }
  }
}
</script>

<style>
</style>
